import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiResponse } from "@biletix/core/models/api-response";
import { ApiService } from "@biletix/core/services/api.service";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { TFFClubInfo } from "@biletix/core/models/tff/TFFClubInfo";
import { TFFTicketDTO } from "@biletix/core/models/tff/TFFTicketDTO";
import { TicketTransferInputDTO } from "@biletix/core/models/tff/TicketTransferInputDTO";
declare const grecaptcha: any;

@Injectable()
export class TFFTicketService {

    private tffBasePath: string = "/api/v1/tff/ticket";

    constructor(private http: HttpClient,
        private apiService: ApiService) {
    }

    getCustomerCombineTickets(): Observable<ApiResponse<TFFTicketDTO[]>> {
        return this.http
            .get<ApiResponse<TFFTicketDTO[]>>(`${this.apiService.getCrmApiHost()}${this.tffBasePath}/getSeasonTicket`)
            .pipe(map(response => response));
    }


    transferTicketControl(request: TicketTransferInputDTO) {
        return this.http
            .post<ApiResponse<any>>(`${this.apiService.getCrmApiHost()}${this.tffBasePath}//transfer/control`, request)
            .pipe(map(response => response.data));
    }

    proceedTicketTransfer(request: TicketTransferInputDTO) {
        return this.http
            .post<ApiResponse<any>>(`${this.apiService.getCrmApiHost()}${this.tffBasePath}//transfer/proceed`, request)
            .pipe(map(response => response.data));
    }

    getCustomerTickets(): Observable<ApiResponse<TFFTicketDTO[]>> {
        return this.http
            .get<ApiResponse<TFFTicketDTO[]>>(`${this.apiService.getCrmApiHost()}${this.tffBasePath}/getTFFTicket`)
            .pipe(map(response => response));
    }
}

